"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryProvider = exports.HISTORY_DEBOUNCE_TIMEOUT = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var HistoryContext_1 = require("./HistoryContext");
var generateHistoryLabel_1 = require("./generateHistoryLabel");
var utils_1 = require("../../utils");
exports.HISTORY_DEBOUNCE_TIMEOUT = 700;
var HistoryProvider = /** @class */ (function (_super) {
    tslib_1.__extends(HistoryProvider, _super);
    function HistoryProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saveHistorySnapshot = function (label, withDebounce) {
            if (_this.props.editorSDK && !_this.batchIsActive) {
                if (!withDebounce) {
                    _this.handleHistoryAddDebounced.finish();
                }
                // We want to disable tslint rule since we handleSetParam should be sync
                // and will be updated to async with the next major release
                // tslint:disable-next-line:no-floating-promises
                _this.props.editorSDK.history.add('', {
                    label: generateHistoryLabel_1.generateHistoryLabel(label, {
                        isMobile: _this.props.isMobile,
                    }),
                });
            }
        };
        _this.handleHistoryAdd = function (label) {
            _this.saveHistorySnapshot(label, false);
        };
        _this.handleHistoryAddDebounced = utils_1.debounce(function (label) {
            _this.saveHistorySnapshot(label, true);
        }, exports.HISTORY_DEBOUNCE_TIMEOUT);
        _this.handleHistoryBatchStart = function () {
            if (!_this.props.editorSDK) {
                return;
            }
            if (_this.batchIsActive) {
                throw new Error('The history batch was already started. Call `history.endBatch(label)` before starting the new batch.');
            }
            _this.batchIsActive = true;
        };
        _this.handleHistoryBatchEnd = function (label) {
            if (!_this.props.editorSDK) {
                return;
            }
            if (!_this.batchIsActive) {
                throw new Error('No batch was started before `history.endBatch` call.');
            }
            _this.batchIsActive = false;
            _this.handleHistoryAdd(label);
        };
        return _this;
    }
    HistoryProvider.prototype.render = function () {
        return (React.createElement(HistoryContext_1.HistoryContext.Provider, { value: {
                add: this.handleHistoryAdd,
                addDebounced: this.handleHistoryAddDebounced,
                startBatch: this.handleHistoryBatchStart,
                endBatch: this.handleHistoryBatchEnd,
            } }, this.props.children));
    };
    HistoryProvider.propTypes = {
        editorSDK: PropTypes.object,
        isMobile: PropTypes.bool,
    };
    return HistoryProvider;
}(React.Component));
exports.HistoryProvider = HistoryProvider;
//# sourceMappingURL=HistoryProvider.js.map